import * as React from 'react';

export interface CookiesPicProps {
  className?: string;
  style?: React.CSSProperties;
}

export const CookiesPic: React.FC<CookiesPicProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 264 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    aria-hidden="true"
    focusable="false"
  >
    <ellipse cx="69" cy="63" rx="68" ry="52" fill="#B0885F" />
    <ellipse cx="69" cy="54" rx="68" ry="52" fill="#D9BC93" />
    <path
      opacity="0.38"
      d="M61 80C88.6142 80 111 64.7777 111 46C111 27.2223 88.6142 12 61 12C33.3858 12 11 27.2223 11 46C11 64.7777 33.3858 80 61 80Z"
      fill="#E5CBA3"
    />
    <path
      d="M32.8811 35.1683C37.0329 33.6572 39.5564 30.1182 38.5175 27.2638C37.4786 24.4094 33.2707 23.3205 29.1189 24.8317C24.967 26.3428 22.4435 29.8818 23.4824 32.7361C24.5213 35.5905 28.7293 36.6794 32.8811 35.1683Z"
      fill="#6B4630"
    />
    <path
      d="M57.7903 22.8515C61.5415 23.7867 65.124 22.3728 65.792 19.6934C66.4601 17.014 63.9607 14.0838 60.2096 13.1485C56.4584 12.2132 52.8759 13.6271 52.2079 16.3065C51.5398 18.9859 54.0392 21.9162 57.7903 22.8515Z"
      fill="#59392A"
    />
    <path
      d="M91.6958 28.9514C95.7976 28.3749 98.8113 25.6908 98.427 22.9562C98.0426 20.2217 94.4059 18.4722 90.3041 19.0487C86.2023 19.6251 83.1886 22.3093 83.5729 25.0438C83.9573 27.7784 87.594 29.5278 91.6958 28.9514Z"
      fill="#6B4630"
    />
    <path
      d="M114.966 52.5677C118.498 54.1402 122.272 53.3698 123.395 50.8472C124.518 48.3245 122.565 45.0047 119.034 43.4323C115.502 41.8598 111.728 42.6302 110.605 45.1528C109.482 47.6755 111.434 50.9953 114.966 52.5677Z"
      fill="#59392A"
    />
    <path
      d="M112.21 82.8515C116.229 81.8494 118.945 78.865 118.277 76.1856C117.609 73.5062 113.809 72.1464 109.79 73.1485C105.771 74.1506 103.055 77.135 103.723 79.8144C104.391 82.4938 108.191 83.8535 112.21 82.8515Z"
      fill="#6B4630"
    />
    <path
      d="M20.6527 70.4147C24.0661 72.2297 27.8842 71.7245 29.1807 69.2863C30.4771 66.8481 28.7609 63.4002 25.3474 61.5853C21.9339 59.7703 18.1158 60.2755 16.8194 62.7137C15.523 65.1519 17.2392 68.5998 20.6527 70.4147Z"
      fill="#59392A"
    />
    <path
      d="M51.4704 96.4753C55.3152 96.0712 58.2215 93.74 57.9617 91.2683C57.7019 88.7966 54.3745 87.1205 50.5296 87.5246C46.6848 87.9288 43.7786 90.26 44.0384 92.7317C44.2982 95.2034 47.6256 96.8795 51.4704 96.4753Z"
      fill="#6B4630"
    />
    <path
      d="M81.7597 96.3257C85.2104 97.3152 88.5632 96.1806 89.2482 93.7916C89.9333 91.4026 87.6912 88.6638 84.2404 87.6743C80.7896 86.6848 77.4369 87.8193 76.7518 90.2083C76.0668 92.5973 78.3089 95.3362 81.7597 96.3257Z"
      fill="#59392A"
    />
    <path
      d="M40.1318 54.924C44.211 55.6433 47.9065 54.0218 48.3861 51.3024C48.8656 48.5829 45.9474 45.7952 41.8682 45.076C37.789 44.3567 34.0935 45.9782 33.6139 48.6976C33.1344 51.4171 36.0525 54.2048 40.1318 54.924Z"
      fill="#6B4630"
    />
    <path
      d="M80.5451 62.7553C84.2218 61.5606 86.5107 58.4632 85.6574 55.8369C84.804 53.2106 81.1317 52.0501 77.4549 53.2447C73.7781 54.4394 71.4892 57.5368 72.3426 60.1631C73.1959 62.7894 76.8683 63.9499 80.5451 62.7553Z"
      fill="#59392A"
    />
    <path
      opacity="0.6"
      d="M29 23.8C30.3255 23.8 31.4 22.9941 31.4 22C31.4 21.0059 30.3255 20.2 29 20.2C27.6745 20.2 26.6 21.0059 26.6 22C26.6 22.9941 27.6745 23.8 29 23.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M64.9999 11.6C66.215 11.6 67.1999 10.8836 67.1999 9.99999C67.1999 9.11634 66.215 8.39999 64.9999 8.39999C63.7849 8.39999 62.7999 9.11634 62.7999 9.99999C62.7999 10.8836 63.7849 11.6 64.9999 11.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M101 19.8C102.325 19.8 103.4 18.9941 103.4 18C103.4 17.0059 102.325 16.2 101 16.2C99.6745 16.2 98.6 17.0059 98.6 18C98.6 18.9941 99.6745 19.8 101 19.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M123 45.6C124.215 45.6 125.2 44.8836 125.2 44C125.2 43.1163 124.215 42.4 123 42.4C121.785 42.4 120.8 43.1163 120.8 44C120.8 44.8836 121.785 45.6 123 45.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M115 73.7C116.215 73.7 117.2 72.9389 117.2 72C117.2 71.0611 116.215 70.3 115 70.3C113.785 70.3 112.8 71.0611 112.8 72C112.8 72.9389 113.785 73.7 115 73.7Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M84.9999 99.6C86.215 99.6 87.1999 98.8837 87.1999 98C87.1999 97.1163 86.215 96.4 84.9999 96.4C83.7849 96.4 82.7999 97.1163 82.7999 98C82.7999 98.8837 83.7849 99.6 84.9999 99.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M49 101.8C50.3255 101.8 51.4 100.994 51.4 100C51.4 99.0059 50.3255 98.2 49 98.2C47.6745 98.2 46.6 99.0059 46.6 100C46.6 100.994 47.6745 101.8 49 101.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M18.9999 77.6C20.215 77.6 21.1999 76.8836 21.1999 76C21.1999 75.1163 20.215 74.4 18.9999 74.4C17.7849 74.4 16.7999 75.1163 16.7999 76C16.7999 76.8836 17.7849 77.6 18.9999 77.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M11 47.8C12.3255 47.8 13.4 46.9941 13.4 46C13.4 45.0059 12.3255 44.2 11 44.2C9.67449 44.2 8.59998 45.0059 8.59998 46C8.59998 46.9941 9.67449 47.8 11 47.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M53 41.4C54.0493 41.4 54.9 40.7732 54.9 40C54.9 39.2268 54.0493 38.6 53 38.6C51.9506 38.6 51.1 39.2268 51.1 40C51.1 40.7732 51.9506 41.4 53 41.4Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M99 47.5C100.105 47.5 101 46.8284 101 46C101 45.1716 100.105 44.5 99 44.5C97.8954 44.5 97 45.1716 97 46C97 46.8284 97.8954 47.5 99 47.5Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M69 77.4C70.0493 77.4 70.9 76.7732 70.9 76C70.9 75.2268 70.0493 74.6 69 74.6C67.9506 74.6 67.1 75.2268 67.1 76C67.1 76.7732 67.9506 77.4 69 77.4Z"
      fill="#F2E3CA"
    />
    <path
      d="M181 19C185.1 19 189.122 19.253 193.041 19.7383C193.015 20.1556 193 20.5762 193 21C193 30.1485 199.143 37.8622 207.528 40.2422C209.417 49.4676 216.193 56.9108 225.031 59.7539C225.01 60.1666 225 60.5821 225 61C225 74.2548 235.745 85 249 85C250.693 85 252.345 84.8238 253.939 84.4902C247.982 110.898 217.594 131 181 131C140.131 131 107 105.928 107 75C107 44.0721 140.131 19 181 19Z"
      fill="#B0885F"
    />
    <path
      d="M181 10C185.1 10 189.122 10.253 193.041 10.7383C193.015 11.1556 193 11.5762 193 12C193 21.1485 199.143 28.8622 207.528 31.2422C209.417 40.4676 216.193 47.9108 225.031 50.7539C225.01 51.1666 225 51.5821 225 52C225 65.2548 235.745 76 249 76C250.693 76 252.345 75.8238 253.939 75.4902C247.982 101.898 217.594 122 181 122C140.131 122 107 96.9279 107 66C107 35.0721 140.131 10 181 10Z"
      fill="#D9BC93"
    />
    <path
      opacity="0.38"
      d="M165 88C189.301 88 209 73.6731 209 56C209 38.3269 189.301 24 165 24C140.699 24 121 38.3269 121 56C121 73.6731 140.699 88 165 88Z"
      fill="#E5CBA3"
    />
    <path
      d="M140.7 47.2308C144.902 45.8655 147.547 42.4168 146.609 39.5279C145.67 36.639 141.503 35.4039 137.3 36.7692C133.098 38.1345 130.453 41.5832 131.392 44.4721C132.33 47.361 136.498 48.5961 140.7 47.2308Z"
      fill="#6B4630"
    />
    <path
      d="M165.96 32.8907C169.742 33.6945 173.273 32.1565 173.847 29.4554C174.421 26.7543 171.821 23.913 168.04 23.1093C164.258 22.3055 160.727 23.8435 160.153 26.5446C159.579 29.2457 162.179 32.0869 165.96 32.8907Z"
      fill="#59392A"
    />
    <path
      d="M183.696 54.9514C187.798 54.3749 190.811 51.6908 190.427 48.9562C190.043 46.2217 186.406 44.4722 182.304 45.0487C178.202 45.6251 175.189 48.3093 175.573 51.0438C175.957 53.7784 179.594 55.5278 183.696 54.9514Z"
      fill="#6B4630"
    />
    <path
      d="M122.808 78.494C126.283 80.1887 130.081 79.5506 131.292 77.0686C132.502 74.5867 130.667 71.2008 127.192 69.506C123.717 67.8113 119.919 68.4495 118.708 70.9314C117.498 73.4134 119.333 76.7992 122.808 78.494Z"
      fill="#59392A"
    />
    <path
      d="M154.04 68.8907C158.091 68.0295 160.91 65.1418 160.336 62.4407C159.762 59.7396 156.012 58.2481 151.96 59.1093C147.909 59.9705 145.09 62.8583 145.664 65.5593C146.238 68.2604 149.988 69.7519 154.04 68.8907Z"
      fill="#6B4630"
    />
    <path
      d="M179.455 92.7553C183.132 93.9499 186.804 92.7894 187.657 90.1631C188.511 87.5369 186.222 84.4394 182.545 83.2447C178.868 82.0501 175.196 83.2106 174.343 85.8369C173.489 88.4632 175.778 91.5606 179.455 92.7553Z"
      fill="#59392A"
    />
    <path
      d="M211.47 82.4753C215.315 82.0712 218.221 79.74 217.962 77.2683C217.702 74.7966 214.374 73.1205 210.53 73.5246C206.685 73.9288 203.779 76.26 204.038 78.7317C204.298 81.2034 207.626 82.8795 211.47 82.4753Z"
      fill="#6B4630"
    />
    <path
      d="M147.911 104.366C151.395 105.235 154.706 103.984 155.307 101.573C155.908 99.161 153.572 96.5021 150.089 95.6337C146.605 94.7652 143.294 96.0161 142.693 98.4275C142.092 100.839 144.428 103.498 147.911 104.366Z"
      fill="#59392A"
    />
    <path
      d="M183.781 116.432C187.317 115.808 189.833 113.319 189.401 110.871C188.97 108.424 185.754 106.945 182.219 107.568C178.683 108.192 176.167 110.681 176.599 113.129C177.03 115.576 180.246 117.055 183.781 116.432Z"
      fill="#6B4630"
    />
    <path
      d="M213.461 104.229C216.575 105.362 219.788 104.388 220.638 102.052C221.488 99.7167 219.653 96.9047 216.539 95.7714C213.425 94.638 210.212 95.6125 209.362 97.9479C208.512 100.283 210.347 103.095 213.461 104.229Z"
      fill="#59392A"
    />
    <path
      d="M230.103 85.845C233.288 84.9317 235.376 82.4697 234.768 80.3462C234.159 78.2226 231.083 77.2416 227.897 78.155C224.712 79.0683 222.624 81.5303 223.232 83.6538C223.841 85.7774 226.917 86.7584 230.103 85.845Z"
      fill="#6B4630"
    />
    <path
      opacity="0.6"
      d="M139 31.8C140.325 31.8 141.4 30.9941 141.4 30C141.4 29.0059 140.325 28.2 139 28.2C137.674 28.2 136.6 29.0059 136.6 30C136.6 30.9941 137.674 31.8 139 31.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M171 19.6C172.215 19.6 173.2 18.8837 173.2 18C173.2 17.1164 172.215 16.4 171 16.4C169.785 16.4 168.8 17.1164 168.8 18C168.8 18.8837 169.785 19.6 171 19.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M119 59.8C120.325 59.8 121.4 58.9941 121.4 58C121.4 57.0059 120.325 56.2 119 56.2C117.674 56.2 116.6 57.0059 116.6 58C116.6 58.9941 117.674 59.8 119 59.8Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M133 95.6C134.215 95.6 135.2 94.8837 135.2 94C135.2 93.1163 134.215 92.4 133 92.4C131.785 92.4 130.8 93.1163 130.8 94C130.8 94.8837 131.785 95.6 133 95.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M171 113.7C172.215 113.7 173.2 112.939 173.2 112C173.2 111.061 172.215 110.3 171 110.3C169.785 110.3 168.8 111.061 168.8 112C168.8 112.939 169.785 113.7 171 113.7Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M211 103.6C212.215 103.6 213.2 102.884 213.2 102C213.2 101.116 212.215 100.4 211 100.4C209.785 100.4 208.8 101.116 208.8 102C208.8 102.884 209.785 103.6 211 103.6Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M235 77.5C236.105 77.5 237 76.8284 237 76C237 75.1716 236.105 74.5 235 74.5C233.895 74.5 233 75.1716 233 76C233 76.8284 233.895 77.5 235 77.5Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M155 47.4C156.049 47.4 156.9 46.7732 156.9 46C156.9 45.2268 156.049 44.6 155 44.6C153.951 44.6 153.1 45.2268 153.1 46C153.1 46.7732 153.951 47.4 155 47.4Z"
      fill="#F2E3CA"
    />
    <path
      opacity="0.6"
      d="M195 83.4C196.049 83.4 196.9 82.7732 196.9 82C196.9 81.2268 196.049 80.6 195 80.6C193.951 80.6 193.1 81.2268 193.1 82C193.1 82.7732 193.951 83.4 195 83.4Z"
      fill="#F2E3CA"
    />
    <path
      d="M241.803 23.2889C244.398 24.2334 247.037 23.5265 247.699 21.7101C248.36 19.8937 246.792 17.6555 244.197 16.7111C241.602 15.7666 238.963 16.4735 238.302 18.2899C237.64 20.1063 239.208 22.3445 241.803 23.2889Z"
      fill="#D9BC93"
    />
    <path
      d="M259.624 40.9345C261.785 40.4752 263.257 38.789 262.913 37.1684C262.568 35.5477 260.537 34.6063 258.376 35.0656C256.215 35.5249 254.743 37.211 255.087 38.8317C255.432 40.4523 257.463 41.3938 259.624 40.9345Z"
      fill="#C9A87C"
    />
    <path
      d="M237.75 6.16507C239.376 7.10396 241.254 6.89574 241.945 5.70001C242.635 4.50427 241.876 2.77383 240.25 1.83495C238.624 0.896062 236.746 1.10428 236.056 2.30001C235.365 3.49574 236.124 5.22619 237.75 6.16507Z"
      fill="#D9BC93"
    />
  </svg>
);
